export default __webpack_public_path__ + "a1af135d6258d54d4717bffc09599618.png";